import { doc, getDoc } from 'firebase/firestore'
import { db } from '@app/firebase'
import { FirestoreCollections, ScoringBySubtestDoc } from '../types'

export const getScoringBySubtest = async (
  userAssessmentId: string,
): Promise<ScoringBySubtestDoc | null> => {
  try {
    const docRef = doc(db, FirestoreCollections.scoringBySubtest, userAssessmentId)
    const docSnap = await getDoc(docRef)
    console.log(docRef)
    if (docSnap.exists) {
      return docSnap.data() as ScoringBySubtestDoc
    }

    return null
  } catch (e) {
    console.error('Cannot get firestore data: ', e)
    return null
  }
}
